/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_UnavailableInputs */

const en_mk_shot_unavailable = /** @type {(inputs: Mk_Shot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This preview is unavailable. Explore the product walkthrough.`)
};

const id_mk_shot_unavailable = /** @type {(inputs: Mk_Shot_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau ini belum tersedia. Jelajahi panduan produknya.`)
};

/**
* | output |
* | --- |
* | "This preview is unavailable. Explore the product walkthrough." |
*
* @param {Mk_Shot_UnavailableInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_unavailable = /** @type {((inputs?: Mk_Shot_UnavailableInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_UnavailableInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_unavailable(inputs)
	return en_mk_shot_unavailable(inputs)
});